import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, ScrollText } from "lucide-react";

const ACTION_COLOR = {
  login: "text-slate-600", register: "text-slate-600",
  consent_accept: "text-green-700", consent_withdraw: "text-red-600",
  voice_capture: "text-blue-700", ai_triage: "text-purple-700",
  genetic_consent: "text-green-700", genetic_status: "text-amber-700",
  report_upload: "text-cyan-700", report_download: "text-cyan-700",
  clinician_review: "text-brand", view_profile: "text-slate-600", view_triage: "text-slate-600",
  create_user: "text-purple-700", update_user: "text-amber-700", update_mapping: "text-amber-700",
  voice_playback: "text-cyan-700",
};

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/admin/audit?limit=300").then((r) => setLogs(r.data.logs)); }, []);
  if (!logs) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div>;

  return (
    <div>
      <div className="eyebrow">Compliance</div>
      <h1 className="font-head text-3xl font-bold text-ink mt-1">Audit log</h1>
      <p className="text-ink-soft mt-1">Immutable record of PHI access and workflow actions.</p>

      <div className="mt-6 rounded-xl border border-slate-200 bg-white overflow-x-auto">
        <table className="w-full text-sm min-w-[760px]">
          <thead className="bg-slate-50 border-b border-slate-200 text-left text-ink-muted">
            <tr>
              <th className="px-4 py-3 font-semibold">Time</th>
              <th className="px-4 py-3 font-semibold">Actor role</th>
              <th className="px-4 py-3 font-semibold">Action</th>
              <th className="px-4 py-3 font-semibold">Resource</th>
              <th className="px-4 py-3 font-semibold">Details</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {logs.map((l) => (
              <tr key={l.id} className="hover:bg-slate-50 transition-colors" data-testid="audit-row">
                <td className="px-4 py-2.5 mono text-xs text-ink-muted whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</td>
                <td className="px-4 py-2.5"><span className="rounded-md bg-slate-100 px-2 py-0.5 text-xs font-semibold text-ink-soft">{l.actor_role}</span></td>
                <td className={`px-4 py-2.5 font-semibold ${ACTION_COLOR[l.action] || "text-ink"}`}>{l.action}</td>
                <td className="px-4 py-2.5 text-ink-soft">{l.resource}</td>
                <td className="px-4 py-2.5 mono text-xs text-ink-muted truncate max-w-[240px]">{Object.keys(l.meta || {}).length ? JSON.stringify(l.meta) : "—"}</td>
              </tr>
            ))}
            {logs.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-12 text-center text-ink-muted"><ScrollText className="h-8 w-8 mx-auto mb-2 text-slate-300" />No events yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
